const form = $('.filter-form-js');
const action = form.attr('action');

form.on('submit', (e) => {e.preventDefault()});

$('.filter-stores-search-js').on('keyup', (e) => submitForm(e));

$('.filter-category-select-js').on('change', (e) => submitForm(e));

$('.filter-view-mode-js').on('change', (e) => submitForm(e));

function submitForm(e){
	const data = new FormData(form[0]);

	$.ajax({
		url: action,
		data: data,
		processData: false,
		contentType: false,
		method: 'POST',
		success: function(response) {
			if (response.status === 'success') {
				url = response.data.url;

				if (window.history.replaceState) {
					window.history.replaceState(response.data, response.data.title, url)
				}

				$.ajax({
					url: url,
					success: function(response) {

						const items = $(response).find('.filter-items-block-js').html();

						$('.filter-items-block-js').empty();
						$('.filter-items-block-js').append(items);
					}
				})
			}
		}
	})
}

